import { Suspense, lazy } from 'react';
import { SegmentedButton } from '@/contasis';
import { useFlujoEfectivoRetroalimentacion } from '../hooks/useFlujoEfectivoRetroalimentacion';
import { useRetroalimentacion } from '../hooks/useRetroalimentacion';
import type { FlujoRetroalimentacion } from '../tipos';
import { BuzonIdeas } from './BuzonIdeas';
import { EncuestaNps } from './EncuestaNps';
import { EstadoAnimoDiario } from './EstadoAnimoDiario';

const DashboardRetroalimentacion = lazy(() => import('./DashboardRetroalimentacion'));

const OPCIONES_FLUJO: Array<{ value: FlujoRetroalimentacion; label: string }> = [
  { value: 'estado_animo', label: 'Estado de ánimo' },
  { value: 'buzon_ideas', label: 'Buzón de ideas' },
  { value: 'nps', label: 'Calificación' },
];

const OPCION_RESULTADOS: { value: FlujoRetroalimentacion; label: string } = { value: 'resultados', label: 'Resultados' };

export function SelectorFlujoRetroalimentacion() {
  const { cambiarFlujo } = useRetroalimentacion();
  const { flujo, esSuperAdmin } = useFlujoEfectivoRetroalimentacion();
  const opciones = esSuperAdmin ? [...OPCIONES_FLUJO, OPCION_RESULTADOS] : OPCIONES_FLUJO;

  return (
    <SegmentedButton
      options={opciones.map(({ value, label }) => ({ value, label }))}
      value={flujo}
      onChange={(value) => cambiarFlujo(value as FlujoRetroalimentacion)}
      fullWidth
      size="sm"
    />
  );
}

export function CuerpoRetroalimentacion() {
  const { flujo } = useFlujoEfectivoRetroalimentacion();

  if (flujo === 'resultados') {
    return (
      <Suspense fallback={<p className="text-ui-sm text-tertiary">Cargando resultados...</p>}>
        <DashboardRetroalimentacion />
      </Suspense>
    );
  }

  return (
    <>
      <p className="mb-4 text-ui-sm text-tertiary">Tu opinión nos ayuda a mejorar.</p>
      {flujo === 'buzon_ideas' && <BuzonIdeas />}
      {flujo === 'nps' && <EncuestaNps />}
      {flujo !== 'buzon_ideas' && flujo !== 'nps' && <EstadoAnimoDiario />}
    </>
  );
}
